export default {
  p3713e00: "M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V16C4 16.5304 4.21071 17.0391 4.58579 17.4142C4.96086 17.7893 5.46957 18 6 18H14C14.5304 18 15.0391 17.7893 15.4142 17.4142C15.7893 17.0391 16 16.5304 16 16V6L14 2Z",
  pd2076c0: "M14 2V6H18",
  p3ee34580: "M12 2.66667H4C3.26362 2.66667 2.66667 3.26362 2.66667 4V13.3333C2.66667 14.0697 3.26362 14.6667 4 14.6667H12C12.7364 14.6667 13.3333 14.0697 13.3333 13.3333V4C13.3333 3.26362 12.7364 2.66667 12 2.66667Z",
}
